// ---------------------------------------------------------
// Datei: auth.ts
// Zweck: Auth-bezogene Konfigurationswerte
// Besonderheiten:
// - Gemeinsame Gnadenfrist für Google One Tap, damit AuthContext
//   und LoginScreen synchron entscheiden, wann One Tap als
//   "nicht erfolgreich" gilt
// ---------------------------------------------------------

// Zeit, die Google One Tap zum stillen Anmelden bekommt, bevor
// die UI von einem nicht angemeldeten Zustand ausgeht. FedCM zeigt bei Bedarf
// kurz eine browserverwaltete Bestätigung; 5,5 Sekunden verhindern, dass der
// Fallback-Button diesen Prompt währenddessen überschreibt.
export const ONE_TAP_GRACE_MS = 5500;

// Timeout für den ersten /auth/me-Versuch. Bewusst kurz, damit ein wirklich
// hängender Upstream nicht 30s (One360-Standard-Timeout) blockiert, bevor der
// manuelle Login-Button erscheint.
export const AUTH_ME_TIMEOUT_MS = 8_000;

// Timeout für den automatischen Retry desselben Tokens (siehe AuthContext).
// Die One360-DEV-API (Azure Container App) skaliert nach Inaktivität auf 0
// Instanzen herunter (minReplicas: 0) - der nächste Request braucht dann einen
// Cold Start, gemessen ca. 31s (direkt gegen die Container-App-URL, Stand
// 2026-07-29). Der Erstversuch-Timeout (8s) reicht dafür nicht, ist aber kein
// echter Hänger. Gilt bewusst auch für PROD (dort immer warm, minReplicas: 1)
// statt per Build-Env zu unterscheiden - PROD zahlt den Preis nur im (seltenen)
// Fall eines echten Ausfalls mit etwas längerem Warten auf den Fallback-Button.
export const AUTH_ME_RETRY_TIMEOUT_MS = 45_000;

// Hostname der DEV-Umgebung - dort (und nur dort) erklärt die UI einen langsamen
// Retry mit einem Cold-Start-Hinweis (siehe App.tsx). Kein Vite-Build-Flag, weil
// DEV und PROD über denselben "vite build"-Aufruf laufen (nur Secrets/Env-Werte
// unterscheiden sich) - ein Build-Flag könnte hier nicht zwischen beiden
// unterscheiden, ein Laufzeit-Check auf location.hostname schon.
export const ONE360_COLDSTART_HINT_HOSTNAME = 'dev.dokuapp.360volt.de';
